import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Caution(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
    >
      <Path
        d="M15.3932 11.3923L9.94299 1.64653C9.06733 0.212525 6.93273 0.21062 6.05589 1.64653L0.605989 11.3923C-0.28917 12.8576 0.794597 14.7132 2.54909 14.7132H13.4496C15.2026 14.7132 16.2883 12.8591 15.3932 11.3923ZM7.99944 12.9544C7.50109 12.9544 7.09542 12.5598 7.09542 12.075C7.09542 11.5903 7.50109 11.1956 7.99944 11.1956C8.4978 11.1956 8.90346 11.5903 8.90346 12.075C8.90346 12.5598 8.4978 12.9544 7.99944 12.9544ZM8.90346 9.43688C8.90346 9.92166 8.4978 10.3163 7.99944 10.3163C7.50109 10.3163 7.09542 9.92166 7.09542 9.43688V5.03998C7.09542 4.5552 7.50109 4.16059 7.99944 4.16059C8.4978 4.16059 8.90346 4.5552 8.90346 5.03998V9.43688Z"
        fill="#F25700"
      />
    </Svg>
  );
}

export default Caution;
